import { ActiveModelAdapter, ActiveModelSerializer } from 'active-model-adapter';
export function initialize(application) {
  application.register('adapter:-active-model', ActiveModelAdapter);
  application.register('serializer:-active-model', ActiveModelSerializer);
}
export default {
  initialize
};